// FETCH ALL ACCOUNT_MASTER
export const FETCH_ALL_ACCOUNT_MASTER_REQUEST = 'FETCH_ALL_ACCOUNT_MASTER_REQUEST';
export const FETCH_ALL_ACCOUNT_MASTER_SUCCESS = 'FETCH_ALL_ACCOUNT_MASTER_SUCCESS';
export const FETCH_ALL_ACCOUNT_MASTER_FAILURE = 'FETCH_ALL_ACCOUNT_MASTER_FAILURE';

export const CREATE_ACCOUNT_MASTER_FORM = 'CREATE_ACCOUNT_MASTER_FORM';

export const CREATE_ACCOUNT_MASTER_FORM_REQUEST = 'CREATE_ACCOUNT_MASTER_FORM_REQUEST';
export const CREATE_ACCOUNT_MASTER_FORM_SUCCESS = 'CREATE_ACCOUNT_MASTER_FORM_SUCCESS';
export const CREATE_ACCOUNT_MASTER_FORM_FAILURE = 'CREATE_ACCOUNT_MASTER_FORM_FAILURE';

export const FETCH_SINGLE_ACCOUNT_MASTER_FORM_REQUEST = 'FETCH_SINGLE_ACCOUNT_MASTER_FORM_REQUEST';
export const FETCH_SINGLE_ACCOUNT_MASTER_FORM_SUCCESS = 'FETCH_SINGLE_ACCOUNT_MASTER_FORM_SUCCESS';
export const FETCH_SINGLE_ACCOUNT_MASTER_FORM_FAILURE = 'FETCH_SINGLE_ACCOUNT_MASTER_FORM_FAILURE';

export const UPDATE_ACCOUNT_MASTER_FORM_REQUEST = 'UPDATE_ACCOUNT_MASTER_FORM_REQUEST';
export const UPDATE_ACCOUNT_MASTER_FORM_SUCCESS = 'UPDATE_ACCOUNT_MASTER_FORM_SUCCESS';
export const UPDATE_ACCOUNT_MASTER_FORM_FAILURE = 'UPDATE_ACCOUNT_MASTER_FORM_FAILURE';

export const DELETE_ACCOUNT_MASTER_FORM_REQUEST = 'DELETE_ACCOUNT_MASTER_FORM_REQUEST';
export const DELETE_ACCOUNT_MASTER_FORM_SUCCESS = 'DELETE_ACCOUNT_MASTER_FORM_SUCCESS';
export const DELETE_ACCOUNT_MASTER_FORM_FAILURE = 'DELETE_ACCOUNT_MASTER_FORM_FAILURE';

export const ACCOUNT_MASTER_FORM_RESET = 'ACCOUNT_MASTER_FORM_RESET';


